import { useState } from "react";
import MapSearchBar from "./MapSearchBar";

export default function Navbar({ onRoleChange, user, floating, onOpenSettings, onSearchSelect }) {
  const [role, setRole] = useState("donor");

  const toggle = (newRole) => {
    setRole(newRole);
    if (onRoleChange) onRoleChange(newRole);
  };

  const tabs = [
    { id: "donor", label: "Donor", color: "green" },
    { id: "receiver", label: "Receiver", color: "blue" },
    { id: "deliver", label: "Deliver", color: "amber" },
  ];

  const tabIndex = tabs.findIndex((t) => t.id === role);

  if (floating) {
    return (
      <nav className="glass-hover fixed z-[1001] flex bg-white/75 backdrop-blur-xl rounded-2xl shadow-lg border border-white/40
        left-2 right-2 top-[max(0.5rem,env(safe-area-inset-top))] md:left-4 md:right-4 md:top-4
        flex-col gap-2 py-2 px-3 md:flex-row md:items-center md:gap-3 md:px-5 md:py-3">
        <div className="flex flex-wrap items-center gap-2 flex-shrink-0 md:flex-nowrap md:gap-3">
          <img src="/image192.png" alt="Leafsy" className="w-6 h-6 md:w-7 md:h-7" />
          <h1 className="font-condensed text-xl font-extrabold text-green-600 tracking-tight md:text-2xl">LEAFSY</h1>
          {user && onOpenSettings && (
            <div className="ml-auto md:ml-0 md:order-3 md:hidden">
              <button
                onClick={onOpenSettings}
                className="btn-pop w-8 h-8 rounded-full flex items-center justify-center text-gray-500 hover:bg-gray-100/80 transition text-sm"
                title="Settings"
              >
                ⚙️
              </button>
            </div>
          )}
          {user && onSearchSelect && (
            <div className="w-full min-w-0 md:hidden md:w-auto">
              <MapSearchBar onSelect={onSearchSelect} className="max-w-none" />
            </div>
          )}
        </div>
        {user && onSearchSelect && (
          <div className="hidden md:block flex-1 min-w-0">
            <MapSearchBar onSelect={onSearchSelect} />
          </div>
        )}
        {user && (
          <div className="flex items-center gap-2 md:ml-auto">
            <div className="relative flex bg-black/5 rounded-2xl p-1 min-w-0 flex-1 md:min-w-[180px] md:flex-initial">
              <div
                className="absolute top-1 bottom-1 rounded-xl bg-white/80 backdrop-blur-xl border border-white/60 shadow-lg transition-all duration-300 ease-[cubic-bezier(0.34,1.56,0.64,1)]"
                style={{
                  width: "calc((100% - 8px) / 3)",
                  left: `calc(4px + ${tabIndex} * (100% - 8px) / 3)`,
                }}
              />
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => toggle(tab.id)}
                  className={`relative z-10 flex-1 px-3 py-2 rounded-xl text-xs font-semibold transition-colors duration-200 ${
                    role === tab.id
                      ? tab.id === "donor"
                        ? "text-green-700"
                        : tab.id === "receiver"
                          ? "text-blue-700"
                          : "text-amber-700"
                      : "text-gray-500 hover:text-gray-700"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
            {onOpenSettings && (
              <button
                onClick={onOpenSettings}
                className="btn-pop hidden md:flex w-8 h-8 rounded-full items-center justify-center text-gray-500 hover:bg-gray-100/80 transition text-sm"
                title="Settings"
              >
                ⚙️
              </button>
            )}
          </div>
        )}
      </nav>
    );
  }

  return (
    <nav className="flex items-center justify-between bg-white shadow px-6 py-4 rounded-2xl mb-6">
      <div className="flex items-center gap-2">
        <img src="/image192.png" alt="Leafsy" className="w-8 h-8" />
        <h1 className="font-condensed text-3xl font-extrabold text-green-600 tracking-tight">LEAFSY</h1>
      </div>
    </nav>
  );
}
